(function () {
  'use strict';

  class ParceiraCtrl {

    constructor($scope, $location, $stateParams, Uos, UoArvoreNivel, UoParceira, AlertMessage) {
      this.scope = $scope;
      this.location = $location;
      this.stateParams = $stateParams;
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.uoParceiraService = UoParceira;
      this.alertMessage = AlertMessage;
      this.uos = [];
      this.carregarUos();
      this.limitUo = 10;
      this.limitParceira = 10;
    }

    loadMoreUos() {
      this.limitUo += 10;
    }

    loadMoreParceiras() {
      this.limitParceira += 10;
    }

    carregarUos() {
      this.uoService.getFilhas().then(data => {
        this.uos = this.uoArvoreNivel.converterEmLista(data.plain());
        this.selecionarUo();
      });
    }

    selecionarUo() {
      if (this.stateParams.uoId > 0) {
        angular.forEach(this.uos, (uo) => {
          if (uo.id.toString() === this.stateParams.uoId) {
            this.parceira.uo = uo;
          }
        });
      }
    }

    salvar() {
      this.scope.cadastroForm.submitted = true;

      if (this.scope.cadastroForm.$valid) {
        this.uoParceiraService.post(this.parceira).then(() => {
          this.alertMessage.create({
            type: 'success',
            message: 'Parceiro salvo com sucesso.',
            appendTo: '.alerta-aqui'
          });
          this.location.path('/uos');
        })
        .catch((error) => {
          this.alertMessage.create({
            type: 'error',
            message: error.data.erro,
            appendTo: '.alerta-aqui'
          });
        });
      }
    }
  }

  /**
   * @ngdoc object
   * @name uos.controller:ParceiraCtrl
   *
   * @description
   *
   */
  angular
    .module('uos')
    .controller('ParceiraCtrl', ParceiraCtrl);
}());
